import React, { useEffect, useState } from "react";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import IconButton from "@material-ui/core/IconButton";
import ResponseTypeComponent from "./ResponseTypeComponent";
import { Grid, Paper } from "@material-ui/core";

const DragHandle = SortableHandle(() => (
  <ListItemIcon>
    <DragHandleIcon />
  </ListItemIcon>
));
const SortableItem = SortableElement(
  ({
    key,
    index,
    question,
    item,
    responseType,
    legend,
    editAction,
    deleteAction,
    mIndex,
    renderItem,
  }) => {
    return (
      <ListItem ContainerComponent="div">
        <Paper
          style={{
            padding: 8,
            width: "80%",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          {renderItem ? (
            renderItem(item, index)
          ) : (
            <>
              <ListItemText primary={question} />
              {responseType && responseType.label && (
                <Grid
                  container
                  item
                  style={{ padding: 10 }}
                  xs={6}
                  justify="center"
                  direction="row"
                >
                  <Grid item xs={9}>
                    <ListItemText
                      primary={"Response Type"}
                      secondary={responseType.label}
                    />
                  </Grid>
                  <Grid
                    container
                    item
                    xs={3}
                    justify="center"
                    alignItems="center"
                  >
                    {
                      <ResponseTypeComponent
                        feedBack={false}
                        typeKey={responseType.title}
                        responseType={responseType}
                      />
                    }
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Paper>
        <ListItemSecondaryAction
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            width: "20%",
          }}
        >
          {editAction && (
            <IconButton
              edge="end"
              aria-label="delete"
              style={{ marginRight: 10 }}
              onClick={() => editAction(item, mIndex)}
            >
              <EditIcon />
            </IconButton>
          )}
          {deleteAction && (
            <IconButton
              edge="end"
              aria-label="delete"
              style={{ marginRight: 10 }}
              onClick={() => deleteAction(item, mIndex)}
            >
              <DeleteIcon />
            </IconButton>
          )}
          <DragHandle />
        </ListItemSecondaryAction>
      </ListItem>
    );
  }
);

const SortableListContainer = SortableContainer(
  ({ items, editAction, deleteAction, renderItem }) => (
    <List component="div">
      {items.map(({ question, responseType, legend }, index) => {
        let item = items[index];
        return (
          <SortableItem
            key={index.toString()}
            index={index}
            question={question}
            item={item}
            responseType={responseType}
            legend={legend}
            editAction={editAction}
            deleteAction={deleteAction}
            mIndex={index}
            renderItem={renderItem}
          />
        );
      })}
    </List>
  )
);

const SortableListComponent = (props) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(props.items);
  }, [props]);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let newArray = arrayMove(items, oldIndex, newIndex);
    setItems((items) => newArray);
    props.onSortFinish(newArray);
  };

  return (
    <SortableListContainer
      items={items}
      editAction={props.editAction}
      deleteAction={props.deleteAction}
      renderItem={props.renderItem}
      helperClass={props.sorting}
      onSortEnd={onSortEnd}
      useDragHandle={true}
      lockAxis="y"
    />
  );
};

export default SortableListComponent;
